import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import "../App.css";

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const drawerWidth = 240;
const navItems = ["Inicio", "Descripción", "Galería", "Equipo", "Contacto"];

export default function DrawerAppBar(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box sx={{ pr: 2, pl: 2 }}>
        <img
          src={"/title_logo.png"}
          alt={"We can dig it"}
          className="image-title"
        />
      </Box>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton href={`#inicio`}>
            <ListItemText primary={'Inicio'} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton href={`#descripcion`}>
            <ListItemText primary={'Descripción'} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton href={`#galeria`}>
            <ListItemText primary={'Galería'} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton href={`#equipo`}>
            <ListItemText primary={'Equipo'} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton href={`#contacto`}>
            <ListItemText primary={'Contacto'} />
          </ListItemButton>
        </ListItem>

      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar component="nav">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          {/*    <Typography
            variant="h4"
            component="div"
            sx={{ display: { xs: "none", sm: "block" },padding:5 }}
          >
            We can dig it
          </Typography> */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <img
              src={"/title_logo.png"}
              alt={"We can dig it"}
              className="image-title"
            />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item}
                sx={{ color: "#fff" }}
                href={`#${item.toLocaleLowerCase()}`}
              >
                {item}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box component="main">
        <Toolbar />

      </Box>
    </Box>
  );
}
